import { useCallback } from "react";

import { Run, Stack } from "types/generated";
import useHasStackWriteAccess from "shared/Stack/access/useHasStackWriteAccess";

import { isRunReviewable } from "../useReviewRun/accessValidation";

const useCanReviewRun = (initialStack?: Stack): ((run?: Run, stack?: Stack) => boolean) => {
  const hasStackWriteAccess = useHasStackWriteAccess();

  return useCallback(
    (run?: Run, stack?: Stack) =>
      isRunReviewable(run) && hasStackWriteAccess(stack || initialStack),
    [hasStackWriteAccess, initialStack]
  );
};

export default useCanReviewRun;
